/* eslint-disable react/jsx-props-no-spreading */
import { Autocomplete, AutocompleteProps } from '@mui/material';
import { UPDropdownItem } from 'components/dropdown';

const AutocompleteWrapper = (
  props: JSX.IntrinsicAttributes & AutocompleteProps<UPDropdownItem, undefined, boolean, boolean, 'div'>,
) => <Autocomplete<UPDropdownItem, undefined, boolean, boolean> {...props} />;

export default AutocompleteWrapper;
